<template>
  <div class="container">
    <div class="filter-box">
      <span>统计时间： </span>
      <el-date-picker
        v-model="date"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="handleDateChange"
      >
      </el-date-picker>

      <el-button @click="getChartColumData" style="margin-left: 10px"
        >查询</el-button
      >
    </div>

    <p class="title">一、平台访问量</p>

    <div class="info-panel">
      <span style="margin-right: 48px">登录次数： {{ infos.loginCount }}</span>
      <span>点击次数： {{ infos.browseCount }}</span>
    </div>

    <div class="charts_panel">
      <div class="chart_left">
        <p class="title">栏目统计</p>
        <div id="chart_column" class="chartbox"></div>
      </div>
      <div class="chart_right">
        <p class="title">时间分布</p>
        <div id="chart_date" class="chartbox"></div>
      </div>
    </div>
    <div class="title" style="margin: 70px 0px;">二、资讯信息更新统计</div>
    <div class="charts_panel">
      <div class="chart_left">
        <div id="chart_info_circle" class="chartbox"></div>
      </div>
      <div class="chart_right">
        <div id="chart_info_column" class="chartbox"></div>
      </div>
    </div>

    <div class="title">三、关键词命中率</div>

    <div class="select">
      <span>请选择模块：</span>
      <el-select
        v-model="typeSolrkey"
        placeholder="请选择"
        @change="handleTypeChange"
      >
        <el-option
          v-for="item in columnList"
          :key="item.typeSolrkey"
          :label="item.typeName"
          :value="item.typeSolrkey"
        >
        </el-option>
      </el-select>
    </div>

    <div class="select_lines">
      <div
        class="line"
        v-for="(item, index) in hitKeywordCountByTypeList"
        :key="index"
      >
        <el-progress
          class="progress"
          :text-inside="true"
          :percentage="item.percent"
          :stroke-width="20"
        ></el-progress>
        <span class="line_title">{{ item.keywordName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { postSelectdataPooling, getPanelQueue } from "@/api/api";
import moment from "moment";

export default {
  data() {
    return {
      searchParams: {
        searchBeginTime: "",
        searchEndTime: "",
      },
      typeSolrkey: "",
      date: [],
      infos: {
        browseCount: 0,
        loginCount: 0,
        browseCountByMonthList: {
          xAxisData: [],
          yAxisData: [],
        },
        browseCountByTypeList: [],
        upgradeCountBySourceList: [],
        upgradeCountByTypeBySourceList: {
          yAxisData: [],
          seriesList: [],
        },
        monthListXAxis: [],
      },
      chart1: null,
      columnList: [],
      hitKeywordCountByTypeList: [],
    };
  },
  mounted() {
    this.getPanelQueue();
    this.getChartColumData();
  },
  methods: {
    handleDateChange(val) {
      this.searchParams.searchBeginTime = moment(val[0]).format("YYYY-MM-DD");
      this.searchParams.searchEndTime = moment(val[1]).format("YYYY-MM-DD");
    },
    format(percent) {
      return;
    },
    // 获取图表数据
    getChartColumData() {
      postSelectdataPooling(this.searchParams).then((res) => {
        if (res.data.code === 200) {
          const data = res.data.data;
          this.infos = { ...data };
          this.getKeywordsData();
          this.handleSetChartColumnData(data);
          this.handleSetChartDateData(data);
          this.handleSetChartInfoCircleData(data);
          this.handleSetChartInfoColumnData(data);
          this.init();
        }
      });
    },
    handleTypeChange() {
      this.getKeywordsData();
    },
    // 获取栏目列表
    getPanelQueue() {
      getPanelQueue().then((res) => {
        let data = res.data.data;
        this.queueId = data.id;
        let nameList = data.typeName.split(",");
        let idList = data.typeId.split(",");
        let keyList = data.solrKey.split(",");

        if (nameList.length === nameList.length) {
          nameList.map((item, index) => {
            let obj = {
              id: idList[index],
              typeName: item,
              typeSolrkey: keyList[index],
            };
            this.columnList.push(obj);
          });
          this.typeSolrkey = this.columnList[0].typeSolrkey;
        } else {
          this.$message.error("栏目查询出错");
          return;
        }
      });
    },
    // 关键词命中率
    getKeywordsData() {
      postSelectdataPooling({
        ...this.searchParams,
        typeSolrkey: this.typeSolrkey,
        typeName: this.columnList.find(
          (item) => item.typeSolrkey === this.typeSolrkey
        ).typeName,
      }).then((res) => {
        if (res.data.code === 200) {
          const data = res.data.data.hitKeywordCountByTypeList;
          this.hitKeywordCountByTypeList = [];
          let totalNum = 0;
          data.map((item) => {
            totalNum = totalNum + parseInt(item.hitCount);
          });
          data.map((item) => {
            this.hitKeywordCountByTypeList.push({
              keywordName: item.keywordName,
              percent:
                parseInt(item.hitCount) + totalNum === 0
                  ? 0
                  : ((parseInt(item.hitCount) / totalNum) * 100).toFixed(2),
            });
          });
        }
      });
    },
    // 初始化图表
    init() {
      this.initChartColumn();
      this.initChartDate();
      this.initChartInfoCircle();
      this.initChartInfoColumn();
    },
    initChartColumn() {
      const myChart = this.$echarts.init(
        document.getElementById("chart_column")
      );
      const option = {
        title: {
          text: "",
        },
        legend: {
          top: "bottom",
        },
        grid: {
          top: 0,
          containLabel: true,
        },
        color: [
          "#4373B2",
          "#92CC76",
          "#FAC858",
          "#EF6666",
          "#73C0DE",
          "#3BA272",
          "#FC8452",
          "#9A60B4",
        ],
        series: [
          {
            name: "栏目统计",
            type: "pie",
            radius: ["15%", "60%"],
            center: ["50%", "50%"],
            roseType: "area",
            data: this.infos.browseCountByTypeList,
          },
        ],
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    initChartDate() {
      const myChart = this.$echarts.init(document.getElementById("chart_date"));
      const option = {
        title: {
          text: "",
        },
        color: [
          "#73C0DE",
          "#38B4FF",
          "#fac858",
          "#80CE6B",
          "#FFC63A",
          "#55C2E2",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: this.infos.browseCountByMonthList.xAxisData,
        },
        grid: {
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.infos.browseCountByMonthList.xAxisData,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: this.infos.browseCountByMonthList.yAxisData,
            type: "line",
            areaStyle: {},
          },
        ],
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    initChartInfoCircle() {
      const myChart = this.$echarts.init(
        document.getElementById("chart_info_circle")
      );

      const option = {
        title: {
          text: "",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          top: "10%",
          left: "right",
          right: "-10%",
          icon: "circle",
          align: "left",
        },
        grid: {
          left: "0",
        },
        color: [
          "#4373B2",
          "#92CC76",
          "#FAC858",
          "#EF6666",
          "#73C0DE",
          "#3BA272",
          "#FC8452",
          "#9A60B4",
        ],
        series: [
          {
            type: "pie",
            radius: ["50%", "65%"],
            label: {
              show: false,
              position: "center",
            },
            left: "0",
            legend: {
              right: "0",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: this.infos.upgradeCountBySourceList,
          },
        ],
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    initChartInfoColumn() {
      const myChart = this.$echarts.init(
        document.getElementById("chart_info_column")
      );
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        color: [
          "#4373B2",
          "#92CC76",
          "#FAC858",
          "#EF6666",
          "#73C0DE",
          "#3BA272",
          "#FC8452",
          "#9A60B4",
        ],
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: this.infos.upgradeCountByTypeBySourceList.yAxisData,
        },
        series: this.infos.upgradeCountByTypeBySourceList.seriesList,
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    // 处理图表数据JSON
    handleSetChartColumnData(data) {
      data.browseCountByTypeList.map((item) => {
        this.infos.browseCountByTypeList.push({
          value: item.browseCount,
          name: item.typeName,
        });
      });
    },
    // 时间分布
    handleSetChartDateData(data) {
      const xAxisData = [];
      const yAxisData = [];
      const MonthList = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      data.browseCountByMonthList.map((item) => {
        yAxisData.push(item.browseCount);
        xAxisData.push(MonthList[parseInt(item.month) - 1]);
      });
      this.infos.browseCountByMonthList = { xAxisData, yAxisData };
    },
    handleSetChartInfoCircleData(data) {
      data.upgradeCountBySourceList.map((item) => {
        this.infos.upgradeCountBySourceList.push({
          value: item.upgradeCount,
          name: item.sourceType,
        });
      });
    },
    handleSetChartInfoColumnData(data) {
      const yAxisData = [];
      const seriesList = [];
      data.upgradeCountByTypeBySourceList[0].upgradeCountBySourceList.map(
        (item) => {
          seriesList.push({
            name: item.sourceType,
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: [],
          });
        }
      );
      data.upgradeCountByTypeBySourceList.map((item) => {
        yAxisData.push(item.typeName);
        item.upgradeCountBySourceList.map((x, index) => {
          seriesList[index].data.push(parseInt(x.upgradeCount));
        });
      });
      this.infos.upgradeCountByTypeBySourceList = {
        yAxisData,
        seriesList,
      };
    },
  },
};
</script>

<style scoped>
.main {
  width: 100%;
  max-width: none;
}

.container {
  padding: 0rem;
}

.info-panel {
  margin-top: 20px;
}

.title {
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 0.9);
  line-height: 20px;
}

.charts_panel {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 32px;
}

.chartbox {
  width: 100%;
  height: 100%;
}

.chart_left {
  width: 500px;
  height: 23rem;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}
.title {
  font-weight: bold;
}

.chart_right {
  width: 700px;
  height: 23rem;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

.select_lines {
}

.line {
  width: 100%;
  display: flex;
  margin-top: 5px;
}

.progress {
  width: 300px;
  margin-right: 20px;
}

.line_title {
  float: left;
}
</style>
